export default "<section [ngClass]=\"{'container-fluid':fluid,'container':!fluid}\">\r\n\t<ng-content></ng-content>\r\n</section>\r\n"